import auth from '@/auth/routes';
import dashboard from '@/dashboard/routes';
import compliance from '@/compliance/routes';
import template from '@/template/routes';
import history from '@/history/routes';
import credits from '@/credits/routes';
import endpoint from '@/endpoint/routes';
import metrics from '@/metrics/routes';
import batch from '@/batch/routes';
import invite from '@/invite/routes';
import recurrent from '@/recurrent/routes';

const routes = [
  ...auth,
  ...dashboard,
  ...compliance,
  ...template,
  ...history,
  ...credits,
  ...endpoint,
  ...metrics,
  ...batch,
  ...invite,
  ...recurrent,
];

export default routes;
